module.exports = __webpack_public_path__ + "img/logo_leybold_sub.3d078910.png";